import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <section
      className="banner_point text_white bg_green_color"
      style={{ background: "#000" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo mb-2">
              <StaticImage
                src="../../../images/case-studies/point2-design/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={204}
                height={153}
              />
            </div>
            <p>
              As clients shared the idea of extracting a digital way to
              incorporate celebrities' signatures with the online ordering
              system, Point 2 Design became a step forward in the digitalization
              of customized order handling. It’s a cutting-edge app developed by
              TekRevol, designed to streamline and enhance the order management
              process by enabling users to add digital signatures to their
              respective orders.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/point2-design/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={846}
                height={649}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
